import { createElement } from "react";
import { createRoot } from "react-dom/client";

let sonner: Promise<typeof import("sonner")> | null = null;

function ensureToaster() {
  if (!sonner) {
    sonner = Promise.all([
      import("sonner"),
      import("@/components/ui/sonner"),
    ]).then(([sonnerMod, ui]) => {
      if (!document.getElementById("cms-toaster")) {
        const node = document.createElement("div");
        node.id = "cms-toaster";
        document.body.appendChild(node);
        createRoot(node).render(
          createElement(ui.Toaster, {
            richColors: true,
            position: "top-center",
          }),
        );
      }
      return sonnerMod;
    });
  }
  return sonner;
}

export async function notify(
  kind: "success" | "error",
  title: string,
  description?: string,
) {
  const { toast } = await ensureToaster();
  toast[kind](title, description ? { description } : undefined);
}
